import { readOnly } from "@ember/object/computed";
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const DropdownSelectBoxRow = dt7948.c(class DropdownSelectBoxRow extends SelectKitRowComponent {
  static {
    dt7948.g(this.prototype, "description", [readOnly("item.description")]);
  }
  #description = (dt7948.i(this, "description"), void 0);
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.icons}}\n      <div class=\"icons\">\n        <span class=\"selection-indicator\"></span>\n        {{#each this.icons as |i|}}\n          {{icon i}}\n        {{/each}}\n      </div>\n    {{/if}}\n\n    <div class=\"texts\">\n      <span class=\"name\">{{htmlSafe this.label}}</span>\n      {{#if this.description}}\n        <span class=\"desc\">{{htmlSafe this.description}}</span>\n      {{/if}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        icon,
        htmlSafe
      })
    }), this);
  }
}, [classNames("dropdown-select-box-row")]);
export default DropdownSelectBoxRow;